document.addEventListener('DOMContentLoaded',function(){
 if(!document.body.classList.contains('template-product'))return;
 var lang=(document.documentElement.lang||'fr').slice(0,2).toLowerCase();
 var copies={
  fr:{description:'DESCRIPTION'},
  en:{description:'DESCRIPTION'},
  es:{description:'DESCRIPCIÓN'}
 };
 var copy=copies[lang]||copies.fr;
 var right=document.querySelector('.bdf-product-right-panel');
 if(!right)return;
 var tabs=right.querySelector('.my-tab');
 if(!tabs||tabs.dataset.bdfAccordion==='1')return;
 var desc=tabs.querySelector('#tab-1'),delivery=tabs.querySelector('#tab-2'),why=tabs.querySelector('#tab-3');
 if(delivery)delivery.remove();
 if(why)why.remove();
 if(!desc)return;
 tabs.dataset.bdfAccordion='1';
 var nav=tabs.querySelector('ul.tabs');if(nav)nav.style.display='none';
 var accordion=document.createElement('div');accordion.className='bdf-product-accordion';
 var items=[
  {title:copy.description,icon:'https://cdn.shopify.com/s/files/1/0632/7717/0912/files/icone_description.png?v=1787437302',panel:desc}
 ];
 items.forEach(function(item){
  if(!item.panel)return;
  var wrap=document.createElement('div');wrap.className='bdf-accordion-item';
  var button=document.createElement('button');button.type='button';button.className='bdf-accordion-trigger';button.setAttribute('aria-expanded','false');
  var icon=document.createElement('span');icon.className='bdf-accordion-icon';icon.setAttribute('aria-hidden','true');
  var iconImg=document.createElement('img');iconImg.src=item.icon;iconImg.alt='';iconImg.decoding='async';iconImg.loading='eager';
  iconImg.style.width='26px';iconImg.style.height='26px';iconImg.style.objectFit='contain';iconImg.style.display='block';iconImg.style.background='transparent';iconImg.style.border='0';iconImg.style.boxShadow='none';
  icon.appendChild(iconImg);
  var label=document.createElement('span');label.className='bdf-accordion-label';label.textContent=item.title;
  var arrow=document.createElement('span');arrow.className='bdf-accordion-arrow';arrow.setAttribute('aria-hidden','true');arrow.textContent='›';
  var content=document.createElement('div');content.className='bdf-accordion-content';content.hidden=true;
  while(item.panel.firstChild)content.appendChild(item.panel.firstChild);
  item.panel.remove();
  button.appendChild(icon);button.appendChild(label);button.appendChild(arrow);
  button.addEventListener('click',function(){
   var open=button.getAttribute('aria-expanded')==='true';
   accordion.querySelectorAll('.bdf-accordion-trigger').forEach(function(b){b.setAttribute('aria-expanded','false')});
   accordion.querySelectorAll('.bdf-accordion-content').forEach(function(c){c.hidden=true});
   if(!open){button.setAttribute('aria-expanded','true');content.hidden=false}
  });
  wrap.appendChild(button);wrap.appendChild(content);accordion.appendChild(wrap);
 });
 tabs.insertBefore(accordion,tabs.firstChild);
});